<div class="dialog-form" style="width: 100%;">
        <app-movement-navigation-plan
          [movementPlan]="movementPlan"
          [isNew]="isNew"
          [hasNavigationPlan]="hasNavigationPlan"
          [slingConfig]="slingConfig"
          [lockExecutionDate]="true"
          (backPageEvent)="previouPage()"
          (cancelPageEvent)="close()"
          (finishEvent)="finish($event)">
        </app-movement-navigation-plan>
</div>